<template>
    <div id="stats-table" class="data-table" border="1">
      <div class="header">
      <div></div><div></div><div>
        <!--<select v-model="selectedCity">
          <option
            @change="onSelectCity"
            v-bind:key="key"
            v-for="(value, key) in cities"
            v-bind:value="key"
          >{{value.name}}</option>
        </select> -->
      </div><div></div><div>
        <select v-model="selectedLanguage" @change="onLanguageChange">
          <option
            v-bind:key="key"
            v-for="(value, key) in {lt: 'Lithuanian', pl: 'Polish'}"
            v-bind:value="key"
          >{{value}}</option>
        </select>
      </div>
      </div>
      <div class="header">
        <div>ID</div><div>Skill</div><div>PROs</div><div>Rate</div><div>Jobs</div>
      </div>
      <div v-for="skill in skills" v-bind:key="skill.id" class="row">
        <div class="cell">{{skill.id}}</div>
        <div class="cell"><router-link :to="{ name: 'skillPage', params: { id: skill.id }}">{{skill.localizedTitle[selectedLanguage]}}</router-link></div>
        <div class="cell">
          <span v-for="(key, value) in skill.cityData" :key="value">
            <div v-if="key.country === selectedLanguage.toUpperCase()"><router-link style="display:block" :to="{ name: 'citySkillPage', params: { id: skill.id, city: value }}">{{value}}</router-link>{{skill.cityData[value].numTotalBusinessPros.length}}:{{skill.cityData[value].numPros.length}}:({{skill.cityData[value].numCalendarPros.length}})</div>
          </span><br />
        </div>
        <div v-if="skill.hourlyRate2.LT.EUR" class="cell" style="background-color: #c7fac3">
          {{skill.hourlyRate2.LT.EUR / 100}} (+{{(skill.hourlyRate2.LT.EUR - skill.hourlyRate.LT.EUR)  / 100}}) EUR
          <br/>{{skill.hourlyRate2.PL.PLN / 100}} PLN
        </div>
        <div v-else class="cell">{{skill.hourlyRate.LT.EUR / 100}} EUR<br/>{{skill.hourlyRate.PL.PLN / 100}} PLN</div>
        <div class="cell" style="padding: 0; margin: 0">
          <div class="job-stats-table data-table" v-if="skill.jobs.length">
            <div v-for="job in skill.jobs" v-bind:key="job.id" class="row">
              <div class="cell"><div class="cell"><router-link :to="{ name: 'jobPage', params: { id: job.id }}">{{job.id}}</router-link></div></div>
              <div class="cell">{{job.localizedTitle[selectedLanguage]}}</div>
              <div class="cell"  :style="job.unitPrice2.LT.EUR ? 'background-color: #c7fac3' : ''">
                {{job.unitPrice.LT.EUR / 100}} EUR<br />
                {{job.unitPrice.PL.PLN / 100}} PLN<br/>
                <span v-if="job.unitPrice2.LT.EUR">{{job.unitPrice2.LT.EUR / 100}} (+{{(job.unitPrice2.LT.EUR - job.unitPrice.LT.EUR) / 100}}) {{ (job.unitPrice2.LT.EUR / 0.8 / 100).toFixed(2) }} EUR</span>
              </div>
              <div class="cell">{{job.durationEstimate}} min</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped lang="less">
#stats-table{
  grid-template-columns: auto auto auto auto auto;
}
.job-stats-table {
  grid-template-columns: auto auto auto auto;
}
</style>

<script>
import api from '../services/api';
import {cities, geo} from 'discontract-js-shared';

export default {
  name: 'jobs',
    data: function() {
    return {
      skills: [],
      // selectedCity: 'vilnius',
      selectedLanguage: localStorage.selectedLanguage || 'lt',
      cities
    }
  },
  methods: {
    onLanguageChange() {
      console.log(this.selectedLanguage);
      localStorage.selectedLanguage = this.selectedLanguage;
      return;
    }
  },
  created: async function() {
    // console.log(translations['skill.electricalInstallation.title']);
    const skills = this.$store.state.skills;
    const users = await api.getPros();
    const jobs = this.$store.state.jobs;
    this.skills = Object.values(skills).filter(s => s.hourlyRate).map(skill => {
      let s = {...skill};
      s.hourlyRate = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, s.hourlyRate || {});
      s.hourlyRate2 = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, s.hourlyRate2 || {});
      s.cityData = {};
      users.forEach(pro => {
        // console.log(pro.businessSkills, s.id);
        if ((pro.businessSkills || []).includes(s.id) && pro.verified && pro.proType === 'business') {
          cities.forEach(city => {
            if (city.hidden) {
              return;
            }
            const cityKey = city.code;
            if (!s.cityData[cityKey]) {
              s.cityData[cityKey] = {country: city.country};
              s.cityData[cityKey].numPros = [];
              s.cityData[cityKey].numCalendarPros = [];
              s.cityData[cityKey].numTotalBusinessPros = [];
            }
            const serviceArea = pro.serviceArea;
            const distance = geo.getDistanceFromLatLonInKm(
              serviceArea.latitude,
              serviceArea.longitude,
              city.location.lat,
              city.location.lng,
            );
            if (distance <= serviceArea.radius / 1000 && (pro.serviceArea.country || 'LT') === city.country) {
              s.cityData[cityKey].numTotalBusinessPros.push(pro.id);
              if (!pro.ordersDisabled) {
                s.cityData[cityKey].numPros.push(pro.id);
                if (pro.availabilityConfig) {
                  s.cityData[cityKey].numCalendarPros.push(pro.id);
                }
              }
            }
          });
        }
      });
      s.jobs = Object.values(jobs).map(j => {
        j.unitPrice = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, j.unitPrice || {});
        j.unitPrice2 = Object.assign({LT: {EUR: 0}, PL: {PLN: 0}}, j.unitPrice2 || {});
        return j;
      }).filter(job => {
        return job.skillId == s.id;
      }).sort((s1, s2) => {
        return s1.id < s2.id;
      });
      return s;
    }).sort((s1, s2) => {
      if ( s1.serviceId < s2.serviceId ){
        return -1;
      }
      if ( s1.serviceId > s2.serviceId ){
        return 1;
      }
      return 0;
    });
  }
}
</script>
